import { Component, DestroyRef, inject, signal } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { TranslocoService } from '@jsverse/transloco';
import { LangDirectionService } from '@rieaya-core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [RouterOutlet, ToastModule],
})
export class AppComponent {
  private translocoService = inject(TranslocoService);
  private langDirectionService = inject(LangDirectionService);
  private titleService = inject(Title);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  isRtl = signal<boolean>(true);

  constructor() {
    this.translocoService.langChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const currentLang = this.translocoService.getActiveLang();
        this.isRtl.set(currentLang === 'ar');
        this.langDirectionService.updateDirection();
        this.titleService.setTitle(
          currentLang === 'ar' ? environment.appTitleAr : environment.appTitleEn
        );
      });

    // Remove url queryParams after reload
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((event) => event instanceof NavigationStart),
        take(1)
      )
      .subscribe((event: NavigationStart) => {
        const hasParams = event.url.includes('?');
        const isTokenUrl = event.url.includes('token=');
        const additionRequestUrl = event.url.includes(
          '/addition-requests/details'
        );
        const ordersUrl = event.url.includes('/dashboard/orders');

        if (hasParams && !isTokenUrl && !additionRequestUrl && !ordersUrl) {
          const cleanUrl = event.url.split('?')[0];

          this.router.navigateByUrl(cleanUrl, {
            replaceUrl: true,
          });
        }
      });
  }
}
